<script>
    // Default Set of Colors
    const colors = [
        '#00C8DD', '#2CBADE', '#3DADDE', '#479FDF', '#4E91DF', '#ABACAF'
    ]

    export default {
        props: {
            initialData: {type: Array, default: () => []},
            fields: {
                type: Object, default: () => {
                    return {category: 'category', value: 'value'}
                }
            },
            numericFields: {type: Array, default: () => []},
            numberFormat: {type: String, default: "#"},
            isSortDesc: {type: Boolean, default: true}
        },
        data() {
            return {
                chart: null,
                colors,
                data: [],
                othersData: []
            }
        },
        mounted() {
            this.buildData()
            this.buildGraph()
        },
        beforeDestroy() {
            this.maybeDisposeGraph()
        },
        methods: {
            buildData() {
                const sort = 'desc'
                const max = 5
                let data = this.initialData.slice()

                // Sort dataset by fieldValue
                if (this.isSortDesc) {
                    data.sort((a, b) => {
                        const valueA = a[this.fields.value]
                        const valueB = b[this.fields.value]

                        let comparison = 0;
                        if (valueA > valueB) {
                            comparison = 1;
                        } else if (valueA < valueB) {
                            comparison = -1;
                        }

                        if (sort === 'desc') {
                            return comparison * -1;
                        }

                        return comparison;
                    })
                }

                if (data.length <= max || data.length === max + 1) {
                    this.data = data
                    return
                }

                const otherData = {}
                otherData[this.fields.category] = "Others"
                if (this.numericFields.length) {
                    this.numericFields.map(field => otherData[field] = 0)
                } else {
                    otherData[this.fields.value] = 0
                }

                data.map((record, index) => {
                    if (index >= max) {
                        if (this.numericFields.length) {
                            this.numericFields.map(field => otherData[field] += record[field])
                        } else {
                            otherData[this.fields.value] += record[this.fields.value]
                        }
                        this.othersData.push(record)
                    }
                })

                data = data.filter((record, index) => index < max)

                this.data = [...data, otherData]
            },
            buildGraph() {
                //
            },
            maybeDisposeGraph() {
                if (this.chart) {
                    this.chart.dispose()
                }
            }
        },
        watch: {
            initialData: {
                handler: function (to, from) {
                    this.buildData();
                    this.maybeDisposeGraph();
                    this.buildGraph();
                },
                deep: true
            }
        },
    }
</script>